<template>
  <div class="search-page">
    <div class="container">
      <div class="search-content">
        <div class="search-bar-wrapper">
          <div class="search-bar">
            <input
              type="text"
              v-model="searchInput"
              placeholder="请输入搜索关键词"
              class="search-input"
              @keyup.enter="handleSearch"
            />
            <button class="search-btn" @click="handleSearch">搜索</button>
          </div>
        </div>
        <div class="search-results">
          <div class="main_left">
            <div class="main_item" v-for="item in searchResults" :key="item.id">
              <div class="main_item_img">
                <img
                  :src="
                    item.image ||
                    'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg'
                  "
                  alt=""
                />
              </div>
              <div
                class="main_item_box"
                @click="goToDetail(item.id)"
                style="cursor: pointer"
              >
                <h1 class="title">
                  {{ newsLng === 2 ? item.title_en || "-" : item.title }}
                </h1>
                <h1 class="content">
                  {{ newsLng === 2 ? item.summary_en || "-" : item.summary }}
                </h1>
                <div class="box_bottom">
                  <div class="theme">
                    <h1>{{ newsLng === 2 ? "Source:" : "来自主题:" }}</h1>
                    <h1 class="theme-text">
                      {{ newsLng === 2 ? item.source_en || "-" : item.source }}
                    </h1>
                    <h1>|</h1>
                    <h1>
                      {{
                        (newsLng === 2 ? item.author_en || "-" : item.author) ||
                        "-"
                      }}
                    </h1>
                  </div>
                  <div class="time">
                    <img src="../assets/time.png" alt="" />
                    <span>{{ item.time || "" }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="more" v-if="searchResults.length > 0" @click="loadMore">
              {{ hasMore ? "点击加载更多" : "没有更多数据了" }}
            </div>
            <div
              class="no-results"
              v-if="keyword && searchResults.length === 0"
            >
              暂无搜索结果
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsListSearch } from "@/api/index";

import { imgBaseURL } from "@/api/index";

export default {
  name: "Search",
  data() {
    return {
      keyword: "",
      searchInput: "",
      searchResults: [],
      hasMore: false,
      currentPage: 1,
      loadingMore: false,
      totalCount: 0,
      newsLng: 1, // 1=中文，2=英文
    };
  },
  created() {
    this.keyword = this.$route.query.keyword || "";
    this.searchInput = this.keyword;
    this.fetchSearchResults();
  },
  watch: {
    $route(to) {
      this.keyword = to.query.keyword || "";
      this.searchInput = this.keyword;
      this.fetchSearchResults();
    },
  },
  methods: {
    handleSearch() {
      if (this.searchInput.trim()) {
        window.open(
          this.$router.resolve({
            path: "/search",
            query: {
              keyword: this.searchInput.trim(),
            },
          }).href,
          "_blank"
        );
      }
    },
    goToDetail(id) {
      const lang = this.newsLng === 2 ? "en" : "zh";
      window.open(
        this.$router.resolve({
          name: "NewsDetail",
          params: { id: id },
          query: { lang: lang },
        }).href,
        "_blank"
      );
    },
    loadMore() {
      if (this.loadingMore || !this.hasMore) return;
      this.loadingMore = true;
      this.fetchSearchResults(true).finally(() => {
        this.loadingMore = false;
      });
    },
    async fetchSearchResults(loadMore = false) {
      if (!this.keyword) {
        this.searchResults = [];
        this.hasMore = false;
        return;
      }
      const page = loadMore ? this.currentPage + 1 : 1;
      try {
        const res = await newsListSearch(this.keyword, page, 20);
        if (res.code === 1 && res.data) {
          const data = res.data;
          this.newsLng = data.news_lng || 1; // 保存语言标识
          const list = (data.news_list || []).map((item) => ({
            ...item,
            image: item.cover_img
              ? item.cover_img.startsWith("http")
                ? item.cover_img
                : imgBaseURL + item.cover_img
              : "",
            title: item.title || "",
            content: item.summary || "",
            theme: item.source || "",
            author: item.author || "",
            time: this.formatTime(item.create_time),
          }));
          if (loadMore) {
            this.searchResults = [...this.searchResults, ...list];
            this.currentPage++;
          } else {
            this.searchResults = list;
            this.currentPage = 1;
          }
          this.totalCount = data.news_count || 0;
          this.hasMore = this.searchResults.length < this.totalCount;
        }
      } catch (error) {
        console.error("搜索失败:", error);
      }
    },
    formatTime(createTime) {
      const ts = Number(createTime);
      if (!ts) return "";
      const now = Date.now();
      const timeMs = ts < 1e12 ? ts * 1000 : ts;
      const diffMs = Math.max(0, now - timeMs);
      const diffSec = Math.floor(diffMs / 1000);
      if (diffSec < 60) return "刚刚";
      const diffMin = Math.floor(diffSec / 60);
      if (diffMin < 60) return `${diffMin}分钟前`;
      const diffHour = Math.floor(diffMin / 60);
      if (diffHour < 24) return `${diffHour}小时前`;
      const d = new Date(timeMs);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
  },
};
</script>

<style scoped lang="scss">
.search-page {
  min-height: 65vh;
  padding: 40px 0;
}

.container {
  max-width: 76rem;
  margin: 0 auto;
  padding: 0 16px;
}

.search-content {
  .search-bar-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }

  .search-bar {
    display: flex;
    width: 800px;
    height: 40px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #90080e;
    overflow: hidden;

    .search-input {
      flex: 1;
      height: 100%;
      padding: 0 15px;
      border: none;
      outline: none;
      font-size: 14px;
      color: #333;

      &::placeholder {
        color: #999;
      }
    }

    .search-btn {
      width: 101px;
      height: 40px;
      background: #90080e;
      border: none;
      color: #ffffff;
      font-size: 19px;
      cursor: pointer;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
      transition: background 0.3s;

      &:hover {
        background: #a40d21;
      }

      &:active {
        background: #7a060a;
      }
    }
  }

  .search-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .search-keyword {
    font-size: 16px;
    color: #666;
    margin-bottom: 30px;
    padding: 15px;
    background: #f5f5f5;
    border-radius: 4px;

    strong {
      color: #a40d21;
      font-weight: bold;
    }
  }

  .search-results {
    min-height: 200px;

    .main_left {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .main_item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e9e9e9;
        padding: 10px 0;
        box-sizing: border-box;
        min-height: 109px;
        .main_item_img {
          width: 220px;
          height: 109px;
          margin-right: 30px;
          display: flex;
          align-items: center;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .main_item_box {
          display: flex;
          flex: 1;
          flex-direction: column;
          justify-content: space-between;
          height: 109px;
          &:hover {
            .title {
              color: #dc0d1d;
            }
            .theme .theme-text {
              color: #dc0d1d;
            }
          }
          .title {
            font-family: MicrosoftYaHeiSemilight;
            font-size: 19px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 10px;
          }
          .content {
            font-family: MicrosoftYaHei;
            font-size: 15px;
            color: #a7a7a7;
            text-align: justifyLeft;
            font-weight: 400;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .box_bottom {
            display: flex;
            justify-content: space-between;
            margin-top: auto;
            .theme {
              display: flex;
              align-items: center;
              gap: 10px;
              h1 {
                font-family: MicrosoftYaHeiSemilight;
                font-size: 13px;
                color: #777777;
                text-align: left;
                margin: 0;
                padding: 0;
                font-weight: normal;
                &:hover {
                  color: #dc0d1d;
                }
              }
            }
            .time {
              display: flex;
              align-items: center;
              img {
                width: 15px;
                height: 15px;
                margin-right: 8px;
              }
              span {
                font-family: MicrosoftYaHeiLight;
                font-size: 13px;
                color: #777777;
              }
            }
          }
        }
      }
      .more {
        width: 230px;
        height: 45px;
        border: 1px solid red;
        font-family: MicrosoftYaHeiSemilight;
        font-size: 16px;
        color: red;
        text-align: center;
        line-height: 45px;
        margin: 50px auto 0;
        cursor: pointer;
        user-select: none;

        &:hover {
          background: rgba(144, 8, 14, 0.05);
        }
      }
      .no-results {
        text-align: center;
        padding: 60px 0;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #999;
      }
    }
  }

  h1 {
    margin: 0;
    padding: 0;
    font-weight: normal;
    font-size: inherit;
  }
}

@media (min-width: 768px) {
  .search-page {
    padding: 60px 0;
  }

  .search-content {
    .search-bar-wrapper {
      margin-bottom: 40px;
    }

    .search-title {
      font-size: 28px;
    }

    .search-keyword {
      font-size: 18px;
      padding: 20px;
    }
  }
}

@media (min-width: 1024px) {
  .search-page {
    padding: 80px 0;
  }

  .search-content {
    .search-bar-wrapper {
      margin-bottom: 50px;
    }

    .search-title {
      font-size: 32px;
    }

    .search-keyword {
      font-size: 20px;
      padding: 25px;
    }
  }
}

@media (max-width: 767px) {
  .search-content {
    .search-bar-wrapper {
      padding: 0 16px;
    }

    .search-bar {
      width: 100%;
      max-width: 800px;
    }

    .search-results {
      .main_left {
        gap: 0;

        .main_item {
          flex-direction: column;
          align-items: stretch;
          padding: 14px 0;
          gap: 10px;

          .main_item_img {
            width: 100%;
            height: auto;
            margin-right: 0;

            img {
              width: 100%;
              height: auto;
              border-radius: 6px;
              display: block;
            }
          }

          .main_item_box {
            &:hover {
              .title {
                color: #dc0d1d;
              }
              .theme h1 {
                color: #dc0d1d;
              }
            }
            .title {
              font-size: 16px;
              margin-bottom: 8px;
              -webkit-line-clamp: 2;
              line-clamp: 2;
            }

            .content {
              font-size: 14px;
              -webkit-line-clamp: 2;
              line-clamp: 2;
            }

            .box_bottom {
              gap: 10px;
              flex-wrap: wrap;

              .theme {
                gap: 6px;

                h1 {
                  font-size: 12px;
                }
              }

              .time span {
                font-size: 12px;
              }
            }
          }
        }

        .more {
          width: 100%;
          max-width: 320px;
          height: 42px;
          line-height: 42px;
          margin: 24px auto 0;
          font-size: 15px;
        }
      }
    }
  }
}
</style>
